import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { actionCreators } from "../redux/activeClientsSagas";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";

const PeriodType = () => {
  const dispatch = useDispatch();
  const periodTypeOptions = useSelector((state) => state.activeClients.periodTypeOptions);
  const selectedPeriodTypeOptions = useSelector(
    (state) => state.activeClients.selectedFilters.period_type
  );

  return (
    <MultiSelectDropdown
      options={periodTypeOptions}
      includeFilter={false}
      numberDisplayed={0}
      selectedFilters={selectedPeriodTypeOptions}
      onSelectChange={(data) => dispatch(actionCreators.updatePeriodType(data))}
    />
  );
};

export default PeriodType;
